import { render, staticRenderFns } from "./ArticleSectionUpdate.vue?vue&type=template&id=6cedbb00&scoped=true&"
import script from "./ArticleSectionUpdate.vue?vue&type=script&lang=js&"
export * from "./ArticleSectionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cedbb00",
  null
  
)

export default component.exports